export default <O>(oldObject: O, newValues: Partial<O>): O => ({ ...oldObject, ...newValues })
